import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications, PurchaseNotification } from '../data/purchaseNotifications';
export function PurchasePopup() {
  const [current, setCurrent] = useState<PurchaseNotification | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const indexRef = useRef(0);
  useEffect(() => {
    if (dismissed) return;
    let hideTimeout: number;
    let showTimeout: number;
    const cycle = () => {
      const next = purchaseNotifications[indexRef.current % purchaseNotifications.length];
      indexRef.current += 1;
      setCurrent(next);
      hideTimeout = window.setTimeout(() => {
        setCurrent(null);
        showTimeout = window.setTimeout(cycle, 9000);
      }, 6000);
    };
    const initial = window.setTimeout(cycle, 6000);
    return () => {
      window.clearTimeout(initial);
      window.clearTimeout(hideTimeout);
      window.clearTimeout(showTimeout);
    };
  }, [dismissed]);
  return <AnimatePresence data-id="element-49" data-mp="116w8clejd5db">
      {current && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed left-3 bottom-24 z-50 w-[min(340px,calc(100vw-1.5rem))] sm:left-5 sm:bottom-6" role="status" aria-live="polite" data-id="element-50" data-mp="116d1bzqfc1e2">
          <div className="relative flex items-start gap-3 rounded-2xl border border-ink-line bg-white p-3.5 pr-9 shadow-[0_18px_40px_-18px_rgba(10,37,64,0.55)]" data-id="element-51" data-mp="i9uzuqlrwn4m">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-cta/10" data-id="element-52" data-mp="s56hphshaagl">
              <CheckCircle2Icon className="h-5 w-5 text-cta" aria-hidden="true" data-id="element-53" data-mp="28jeoo40rmb74" />
            </span>
            <div className="min-w-0" data-id="element-54" data-mp="23kld4h51gu9l">
              <p className="text-[13px] font-bold leading-snug text-ink" data-id="element-55" data-mp="23npp40oqwuat">
                {current.name}{' '}
                <span className="font-semibold text-ink-soft" data-id="element-56" data-mp="2fno1haoghc05">
                  just purchased Renal Decision Desk™
                </span>
              </p>
              <p className="mt-0.5 text-[11.5px] font-medium text-ink-soft" data-id="element-57" data-mp="2knadxhwgmo7w">
                {current.flag} {current.country} · a few minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-ink-soft/70 transition-colors duration-150 ease-out hover:bg-cream hover:text-ink" data-id="element-58" data-mp="1rz4t6v5eoz82">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="26nrhvngxb3by" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}